export enum LogoutType {
    Manual = 'manual',
    Deletion = 'deletion',
    Timeout = 'timeout'
}